import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, api, getErrorMessage } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("levami_admin_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("levami_admin_email"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function check() {
      if (token) {
        try {
          const res = await adminApi.get("/admin/me");
          setEmail(res.data.email);
        } catch {
          setToken(null);
          localStorage.removeItem("levami_admin_token");
        }
      }
      setLoading(false);
    }
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = useCallback(async (loginEmail, password) => {
    const res = await api.post("/admin/login", { email: loginEmail, password });
    localStorage.setItem("levami_admin_token", res.data.token);
    localStorage.setItem("levami_admin_email", res.data.email);
    setToken(res.data.token);
    setEmail(res.data.email);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("levami_admin_token");
    localStorage.removeItem("levami_admin_email");
    setToken(null);
    setEmail(null);
  }, []);
  const changePassword = useCallback(async (current, next) => {
    const { data } = await adminApi.post("/admin/change-password", { current_password: current, new_password: next });
    if (data.token) { localStorage.setItem("levami_admin_token", data.token); setToken(data.token); }
  }, []);

  return (
    <AdminAuthContext.Provider value={{ token, email, loading, login, logout, changePassword, isAuthenticated: !!token }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
